<template>
    <div class="test-statistics-tabs">
        <test-page-header
            :title=trans.statistics.title
            :is-one-line-title="true"
            :return-button="returnButton"
        />
        <div class="test-statistics-tab fixed-with-overflow-y small-scrollbar">
            <tabs>
                <tab
                    :name="trans.statistics.tabs.users"
                    :selected="true"
                >
                    <tabs class="mt-1">
                        <tab :name="trans.statistics.tabs.done" :selected="true">
                            <test-statistics-table
                                :table-data="testStatisticUsers['users']"
                                :headers="usersTableHeaders"
                                :link-collback="showSessions"
                            />
                        </tab>
                        <tab :name="trans.statistics.tabs.in_progress">
                            <test-statistics-table
                                :table-data="testStatisticUsersUnclosed['users']"
                                :headers="usersTableHeaders"
                                :link-collback="showUnclosedSessions"
                            />
                        </tab>
                    </tabs>
                </tab>
                <tab
                    :name="trans.statistics.guests"
                >
                    <tabs class="mt-1">
                        <tab :name="trans.statistics.tabs.done" :selected="true">
                            <test-statistics-table
                                v-if="isShowAnonTable || !isShowGuestsTable"
                                :table-data="testStatisticUsers['anon']"
                                :headers="usersTableHeaders"
                                :link-collback="showSessions"
                                :title="trans.edit_form.can_anonymous"
                            />

                            <test-statistics-table
                                v-if="isShowGuestsTable"
                                :table-data="testStatisticUsers['guests']"
                                :headers="usersTableHeaders"
                                :link-collback="showSessions"
                                is-show-email
                                :title="trans.statistics.with_emails"
                            />
                        </tab>
                        <tab :name="trans.statistics.tabs.in_progress">
                            <test-statistics-table
                                :table-data="testStatisticUsersUnclosed['anon']"
                                :headers="usersTableHeaders"
                                :link-collback="showUnclosedSessions"
                                :title="trans.edit_form.can_anonymous"
                            />
                            <test-statistics-table
                                v-if="isShowTable(testStatisticUsersUnclosed['guests'])"
                                :table-data="testStatisticUsersUnclosed['guests']"
                                :headers="usersTableHeaders"
                                :link-collback="showUnclosedSessions"
                                :title="trans.statistics.with_emails"
                            />
                        </tab>
                    </tabs>



                </tab>
                <tab
                    :name="trans.statistics.tabs.questions"
                >
                    <test-statistics-table
                        :table-data="testStatisticQuestions"
                        :headers="questionsTableHeaders"
                        :link-collback="showUsersForQuestion"
                    />
                </tab>
            </tabs>
        </div>
    </div>
</template>

<script>
import TestPageHeader from "../TestPageHeader";
import {mapActions, mapGetters} from "vuex";
import Tabs from "../../../utils/tabs/Tabs";
import Tab from "../../../utils/tabs/Tab";
import TestStatisticsTable from "./TestStatisticsTable";
import {questionsTable, usersTable} from "../../../../config/tests/statisticsTables";

export default {
    name: "TestStatisticsTabs",
    components: {TestStatisticsTable, Tabs, Tab, TestPageHeader},
    data() {
        return {
            usersTableHeaders: usersTable,
            questionsTableHeaders: questionsTable,
        };
    },
    computed: {
        ...mapGetters('tests', [
            'trans',
            'testStatistic',
            'testStatisticUsers',
            'testStatisticUsersUnclosed',
            'testStatisticQuestions',
        ]),
        isShowGuestsTable() {
            return Object.keys(this.testStatisticUsers['guests'] ?? {}).length > 0;
        },
        isShowAnonTable() {
            return Object.keys(this.testStatisticUsers['anon'] ?? {}).length > 0;
        },
        returnButton() {
            return {
                text: this.trans.show_form.return_button,
                handler: this.returnToTestListPage,
            }
        },
    },
    methods: {
        ...mapActions('tests', [
            'returnToTestListPage',
            'showTestStatisticsSessions',
            'showTestStatisticsUsersForQuestion',
        ]),
        showSessions(user) {
            this.showTestStatisticsSessions({
                user: user,
                isClosed: true
            });
        },
        showUnclosedSessions(user) {
            this.showTestStatisticsSessions({
                user: user,
                isClosed: false
            });
        },
        showUsersForQuestion(question) {
            this.showTestStatisticsUsersForQuestion(question);
        },
        isShowTable(items) {
            if (!items) {
                items = {};
            }

            return Object.keys(items).length > 0;
        }
    }
}
</script>

<style lang="scss">
    .bulma .test-statistics-tab {
        font-size: 18px;
        .tabs-container {
            .tabs-details {
                background: #ffffff;
                border-top: 2px solid #ECECEC;
                border-radius: 0;
                padding: 0;
            }

            .tabs a {
                font-weight: bold;
                color: #000000;
            }
        }
    }
</style>